import axios from 'axios';

export default{
    fetchDatasets(SD,ED) {
        return axios.get("https://hrv.insec.org.np/api/v1/event-types?start_date=" + SD + "&end_date=" + ED);
        // return axios.get("https://hrv.insec.org.np/api/v1/event-types?");
    },
}